import tokens from './tokens'

const lpTokens = {
  pgunk_ftm_spirit_lp: {
    symbol: 'FTM-PGUNK LP SPIRIT',
    address: {
      250: '0x98f70fc717ADcAdE6B0A24df54c49EAbDc5EFC46',
      4002: '',
    },
    token: tokens.pgunk,
    quoteToken: tokens.wftm,
  },
  dmd_dai_lp: {
    symbol: 'DMD-DAI LP',
    address: {
      250: '0xc3f95F723921350caE9022b022E523f09454DC44',
    },
    token: tokens.dmd,
    quoteToken: tokens.dai,
  },
  dmd_usdc_lp: {
    symbol: 'DMD-USDC LP',
    address: {
      250: '0xf62475CbD5121e56FB09Eb9727Dd95e0755414aE',
    },
    token: tokens.dmd,
    quoteToken: tokens.usdc,
  },
  dmd_wftm_lp: {
    symbol: 'DMD-FTM LP',
    address: {
      250: '0xF10F0EeB144Eb223DD8Ae7d5dd7f3327E63A3C94',
    },
    token: tokens.dmd,
    quoteToken: tokens.wftm,
  },
  dmd_fusdt_lp: {
    symbol: 'DMD-FUSDT LP',
    address: {
      250: '0x03da3E1c3b4Aa7f5458D63a45Ca345e8bC470b15',
    },
    token: tokens.dmd,
    quoteToken: tokens.usdt,
  },
  ftm_boo_lp: {
    symbol: 'FTM-BOO LP',
    address: {
      250: '0xEc7178F4C41f346b2721907F5cF7628E388A7a58',
    },
    token: tokens.boo,
    quoteToken: tokens.wftm,
  },
  ftm_wbtc_lp: {
    symbol: 'FTM-WBTC LP',
    address: {
      250: '0xFdb9Ab8B9513Ad9E419Cf19530feE49d412C3Ee3',
    },
    token: tokens.btc,
    quoteToken: tokens.wftm,
  },
  ftm_weth_lp: {
    symbol: 'FTM-WETH LP',
    address: {
      250: '0xf0702249F4D3A25cD3DED7859a165693685Ab577',
    },
    token: tokens.eth,
    quoteToken: tokens.wftm,
  },
  usdc_ftm_lp: {
    symbol: 'USDC-FTM LP',
    address: {
      250: '0x2b4C76d0dc16BE1C31D4C1DC53bF9B45987Fc75c',
    },
    token: tokens.wftm,
    quoteToken: tokens.usdc,
  },
  dai_ftm_lp: {
    symbol: 'DAI-FTM LP',
    address: {
      250: '0xe120ffBDA0d14f3Bb6d6053E90E63c572A66a428',
    },
    token: tokens.dai,
    quoteToken: tokens.wftm,
  },
  ftm_mim_lp: {
    symbol: 'FTM-MIM LP',
    address: {
      250: '0x6f86e65b255c9111109d2D2325ca2dFc82456efc',
    },
    token: tokens.mim,
    quoteToken: tokens.wftm,
  },
  ftm_bnb_lp: {
    symbol: 'FTM-BNB LP',
    address: {
      250: '0x956DE13EA0FA5b577E4097Be837BF4aC80005820',
    },
    token: tokens.bnb,
    quoteToken: tokens.wftm,
  },
  usdc_dai_lp: {
    symbol: 'USDC-DAI LP',
    address: {
      250: '0x484237bc35cA671302d19694c66d617142FBC235',
    },
    token: tokens.usdc,
    quoteToken: tokens.dai,
  },
  usdc_fusdt_lp: {
    symbol: 'USDC-FUSDT LP',
    address: {
      250: '0xFdef392aDc84607135C24ca45DE5452d77aa10DE',
    },
    token: tokens.usdt,
    quoteToken: tokens.usdc,
  },
  wbtc_weth_lp: {
    symbol: 'WBTC-WETH LP',
    address: {
      250: '0xEc454EdA10accdD66209C57aF8C12924556F3aBD',
    },
    token: tokens.btc,
    quoteToken: tokens.eth,
  },
  mim_slurp_lp: {
    symbol: 'MIM-SLURP LP',
    address: {
      250: '0x402474D409Fe3376d9D90efFe8a478659BEeF14d',
    },
    token: tokens.slurp,
    quoteToken: tokens.mim,
  },
  dmd_dola_lp: {
    symbol: 'DMD-DOLA LP',
    address: {
      250: '0x527b5590B062F4e93CDB1eE518498E9a4Aa8F034',
    },
    token: tokens.dola,
    quoteToken: tokens.dmd,
  },
  dmd_weth_lp: {
    symbol: 'DMD-ETH LP',
    address: {
      250: '0x0967B636Ec4C02569d6Cfc4F97fd7Df8Dad4E9A9',
    },
    token: tokens.eth,
    quoteToken: tokens.dmd,
  },
  dmd_wbtc_lp: {
    symbol: 'DMD-BTC LP',
    address: {
      250: '0xf6862656CbEDAF8146474EF0AF926f01c352178B',
    },
    token: tokens.btc,
    quoteToken: tokens.dmd,
  },
  dmd_mim_lp: {
    symbol: 'DMD-MIM LP',
    address: {
      250: '0x38dA6316eAEeE5E87D7BA1ae8b101e5207509B0a',
    },
    token: tokens.mim,
    quoteToken: tokens.dmd,
  },
  crv_ftm_lp: {
    symbol: 'CRV-FTM LP',
    address: {
      250: '0xB471Ac6eF617e952b84C6a9fF5de65A9da96C93B',
    },
    token: tokens.crv,
    quoteToken: tokens.wftm,
  },
  sushi_ftm_lp: {
    symbol: 'SUSHI-FTM LP',
    address: {
      250: '0xf84E313B36E86315af7a06ff26C8b20e9EB443C3',
    },
    token: tokens.sushi,
    quoteToken: tokens.wftm,
  },
  r4id_usdc_lp: {
    symbol: 'R4ID-USDC LP',
    address: {
      250: '0x97a1CB6B891904c3c7797970D2D8F1e4Ecd42Ae0',
    },
    token: tokens.r4id,
    quoteToken: tokens.usdc,
  },
  ape_wftm_lp: {
    symbol: 'APE-WFTM LP',
    address: {
      250: '0xC9FB686f14bDA7e2653cF8F605Dc8551B6a53FD3',
    },
    token: tokens.ape,
    quoteToken: tokens.wftm,
  },
  cgs_wftm_lp: {
    symbol: 'FTM-CGS LP',
    address: {
      4002: '',
      250: '0x2b5965F901f8817DA4D660c64051bA8ADCdc495E',
    },
    token: tokens.cgs,
    quoteToken: tokens.wftm,
  },
  egunk_wftm_lp: {
    symbol: 'FTM-EGUNK LP',
    address: {
      4002: '',
      250: '0x486151C9611E27Dd7bc7257f761774876d54F94F',
    },
    token: tokens.egunk,
    quoteToken: tokens.wftm,
  },
  egunk_wftm_spirit_lp: {
    symbol: 'FTM-EGUNK LP SPIRIT',
    address: {
      4002: '',
      250: '0xbAd86C3Af7Ae1d4FB074155A01e7927AF2786d1C',
    },
    token: tokens.egunk,
    quoteToken: tokens.wftm,
  },
  pgunk_wftm_lp: {
    symbol: 'FTM-PGUNK LP',
    address: {
      4002: '',
      250: '0xC30FA09417F149892Ff86eF92a051c0bC2244c7C',
    },
    token: tokens.pgunk,
    quoteToken: tokens.wftm,
  },
  nips_wftm_lp: {
    symbol: 'FTM-NIPS LP',
    address: {
      4002: '',
      250: '0xe54dc3a288e0f3c5cc28eb3d52df27e26f9bafb8',
    },
    token: tokens.nips,
    quoteToken: tokens.wftm,
  },
  reaper_wftm_lp: {
    symbol: 'FTM-REAPER LP',
    address: {
      4002: '',
      250: '0x355416b389A25244F4b842516fbD98dE869BBb74',
    },
    token: tokens.reaper,
    quoteToken: tokens.wftm,
  },
  yoshi_usdc_lp: {
    symbol: 'YOSHI-USDC LP',
    address: {
      4002: '',
      250: '0xCf704f9C44b305a2b685c3a96BB19696612cc6bA',
    },
    token: tokens.yoshi,
    quoteToken: tokens.usdc,
  },
  yoshi_wftm_lp: {
    symbol: 'YOSHI-FTM LP',
    address: {
      4002: '',
      250: '0x51D493C9788F4b6F87EAe50F555DD671c4Cf653E',
    },
    token: tokens.yoshi,
    quoteToken: tokens.wftm,
  },
  devil_mim_lp: {
    symbol: 'DEVIL-MIM LP',
    address: {
      4002: '',
      250: '0x0DF9996535F7d86f6c2981b657e549A3d49513E8',
    },
    token: tokens.devil,
    quoteToken: tokens.mim,
  },
  snt_wftm_lp: {
    symbol: 'SNT-WFTM LP',
    address: {
      4002: '',
      250: '0x656aaD6d994CB71F9A4738CAE58Ee64feE72345d',
    },
    token: tokens.snt,
    quoteToken: tokens.wftm,
  },
  magik_wftm_lp: {
    symbol: 'MAGIK-WFTM LP',
    address: {
      4002: '',
      250: '0xDc71A6160322ad78DaB0abb47C7A581cFE9709Ee',
    },
    token: tokens.magik,
    quoteToken: tokens.wftm,
  },
  ham_wftm_lp: {
    symbol: 'HAM-WFTM LP',
    address: {
      4002: '',
      250: '0x8D1963111AA50a9ae9F8ab5006C204cc46bbF4eD',
    },
    token: tokens.ham,
    quoteToken: tokens.wftm,
  },
  ust_ftm_lp: {
    symbol: 'UST-FTM LP',
    address: {
      4002: '',
      250: '0x656b3264695690322ACBad95F994b51C5a8C8eDF',
    },
    token: tokens.ust,
    quoteToken: tokens.wftm,
  },
  luna_ftm_lp: {
    symbol: 'LUNA-FTM LP',
    address: {
      4002: '',
      250: '0xD8934C58dE27e7B6342924B185dA0B3AB009F959',
    },
    token: tokens.luna,
    quoteToken: tokens.wftm,
  },
  ring_usdc_lp: {
    symbol: 'RING-USDC LP',
    address: {
      4002: '',
      250: '0x84fc84B998A01e34c8A9714A600aeBDe8b4Cc671',
    },
    token: tokens.ring,
    quoteToken: tokens.usdc,
  },
  gem_wftm_lp: {
    symbol: 'GEM-WFTM LP',
    address: {
      4002: '',
      250: '0x45F165136caE51dA15535C30fF47B551bB720845',
    },
    token: tokens.gem,
    quoteToken: tokens.wftm,
  },
  gem_ham_lp: {
    symbol: 'GEM-HAM LP',
    address: {
      4002: '',
      250: '0x8D0A916BD1D2255Ee579E8035d2a957284a2A34A',
    },
    token: tokens.gem,
    quoteToken: tokens.ham,
  },
}

export default lpTokens
